module.exports = __webpack_public_path__ + "img/preferred-servicing.54e99b6c.jpg";